module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_4.a3b96605.png";